<div class="pec-app">
  <pec-sidebar />
  <div class="pec-main">
    <pec-topbar />

    @if (isLoading()) {
      <div class="loading-overlay">
        <img src="assets/images/caricamento-pec-engine.svg" alt="Caricamento..." />
      </div>
    }
    <main class="pec-content">
      <router-outlet />
    </main>
  </div>
</div>
<pec-compose-dialog />
